import React from 'react';
import styles from './style/pageHeader.module.css';

interface PageHeaderProps {
  children?: React.ReactChild,
  customHeight?: number | string,
  heading?: string,
  loading?: boolean,
  subHeading?: string,
}

function PageHeader({
  children,
  customHeight,
  heading,
  loading,
  subHeading,
}:PageHeaderProps) {
  const setHeight = {
    height: customHeight,
  };

  return (
    <div className={styles.pageHeader} style={setHeight}>
      { loading ? (
        <div className={styles.pageHeader__loading}>
          <span />
          { subHeading && (
            <span />
          )}
        </div>
      ) : (
        <>
          <h2 className="display4">{ heading }</h2>
          { subHeading && (<p className="subtitle1">{ subHeading }</p>)}
          { children && (<>{ children }</>)}
        </>
      )}
    </div>
  );
}

PageHeader.defaultProps = {
  children: null,
  customHeight: '',
  heading: '',
  loading: false,
  subHeading: '',
};

export default PageHeader;
